// extracted by mini-css-extract-plugin
export default {"container":"routeDetail_container__ZstoI","duration":"routeDetail_duration__133Qm","stopsList":"routeDetail_stopsList__S854-"};